import React, { useState } from 'react';
import { useAppSettings } from '../../context/AppSettingsContext';

// Reusable logo component for login/signup pages
export default function AppLogo({ size = 'md' }) {
  const settings  = useAppSettings();
  const [failed, setFailed] = useState(false);

  const logoSrc = (!failed && settings.appLogo) ? settings.appLogo : '/logo.png';
  const appName = settings.appName || 'Faristaa';

  const heights = { sm: 36, md: 52, lg: 72 };
  const h = heights[size] || 52;

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4 }}>
      {!failed ? (
        <img
          src={logoSrc}
          alt={appName}
          style={{ height: h, width: 'auto', objectFit: 'contain', maxWidth: 200 }}
          onError={() => setFailed(true)}
        />
      ) : (
        <span style={{
          fontSize: h * 0.55, fontWeight: 900, color: '#0D9488',
          fontFamily: 'system-ui, -apple-system, sans-serif', letterSpacing: '-0.5px',
        }}>
          {appName}
        </span>
      )}
    </div>
  );
}
